import React, { useState } from 'react'
import { Field } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'
import { Card, CardActionArea, Dialog } from '@material-ui/core'
import EstadoCallesDeCalado from '../components/EstadoCallesDeCalado'
import DialogView from '../../Dialogos/DialogView'
import { COLORES } from '../../../config/colores'
import { updateEstadoBarchar } from '../actions'
import { connect } from 'react-redux'

function CalleGrande (props) {
  const { data, calificacionCalles, updateEstadoBarchar } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    updateEstadoBarchar(true)
  }
  const handleClose = () => {
    setOpen(false)
    updateEstadoBarchar(false)
  }

  return (
    <Card>
      <CardActionArea
        style={{
          display: 'block',
          padding: '8px',
          margin: 0,
          backgroundColor: COLORES.grey.light
        }}
        onClick={handleOpen}
      >
        <Field
          className='calle-grande'
          name='calle'
          type='number'
          label='Enviar a la calle'
          component={renderTextField}
          aria-disabled
          autoFocus={false}
        />
      </CardActionArea>

      { (data.length > 0) && <Dialog
        open={open}
        onClose={handleClose}
        fullScreen
        style={{ padding: '8px' }}
      >
        <DialogView
          cancelCallback={handleClose}
          title='Estado de ocupación de las calles'
          content={
            <EstadoCallesDeCalado
              width={1000}
              height={450}
              calificacionCalles={calificacionCalles}
              data={data}
              handleClose={handleClose}
            />

          }
        />

      </Dialog>}
    </Card>
  )
}

const mapActionsToProps = {
  updateEstadoBarchar
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(CalleGrande)
